import axios from 'axios';
import { CF7_Checkbox, CF7_Field_Validator } from './forms';

export default class ContactPopups {
    constructor()
    {
        this.open_popups_buttons = document.querySelectorAll('[data-open-contact-form]');
        this.popup_wrapper = document.querySelector('[data-contact-popup]');
        this.close_by_key = false;
    }

    init()
    {
        if (!this.open_popups_buttons || !this.popup_wrapper) {
            return false;
        }

      document.body.addEventListener('click', (event) => {
        if (event.target.classList.contains('otworz-formularz')) {
          event.preventDefault();
          this.openPopup();
          this.loadForm(event.target);
        }
      });


      this.open_popups_buttons.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                this.openPopup();
                this.loadForm(elem);
            })
        })

        document.querySelector('[data-close-popup]').addEventListener('click', (e) => {
            e.preventDefault();
            this.closePopup();
        })


        this.close_by_key = function close_callback(event)
        {
            this.closePopupByKey(event);
        }.bind(this);
    }

    openPopup()
    {
        document.body.classList.toggle('block-scrolling');
        this.popup_wrapper.classList.add('active');
        let header_height = document.querySelector('[data-site-header]').offsetHeight;
        this.popup_wrapper.style.paddingTop = header_height + 65 + 'px';

        document.addEventListener('keydown', this.close_by_key, true);
    }

    closePopupByKey(event)
    {
        if (event.key === "Escape") {
            this.closePopup();
        }
    }

    closePopup()
    {
        document.body.classList.remove('block-scrolling');
        this.popup_wrapper.classList.add('is-send');
        setTimeout(() => {
            this.popup_wrapper.classList.remove('active');
            this.popup_wrapper.classList.remove('is-send');
        }, 400);
        document.removeEventListener('keydown', this.close_by_key, true);
    }


    loadForm(button)
    {

        let content = document.querySelector('[data-form-content]');
        content.innerHTML = '';

        const id = button.dataset.cf7Id;
        const cf7_name = button.dataset.cf7Title;
        const form_name = button.dataset.formName;

        const ajax_form_data = new FormData;
        ajax_form_data.append('action', 'getFormContent');
        ajax_form_data.append('id', id);
        ajax_form_data.append('title', cf7_name);
        ajax_form_data.append('name', form_name);


        let that = this;


        axios.post(ajax_object.ajax_url, ajax_form_data).then(function (response) {
            content.innerHTML = response.data;
            document.querySelectorAll(".wpcf7 > form").forEach((
                    function (e) {
                        return wpcf7.init(e);
                    }
                ));

            that.pseudoDatcePickers();
            that.animateLabels();
            that.showMoreText();
            that.hidePopupAfterSubmit();
            that.formHandler();

        })
    }

    formHandler()
    {
      // checkboxes
        let acceptances = this.popup_wrapper.querySelectorAll('.js-acceptance');

        acceptances.forEach(acceptance => {
            let checkbox = acceptance.querySelector('input');
            let fake_checkbox = acceptance.querySelector('.js-checkbox');

            let field = new CF7_Checkbox(acceptance, checkbox, fake_checkbox);

        });

        let checkboxes = this.popup_wrapper.querySelectorAll('.js-checkbox-parent');

        checkboxes.forEach(checkbox => {
            let field = new CF7_Checkbox(checkbox, checkbox.querySelector('input'), checkbox.querySelector('.js-checkbox'));
        });


        let forms = this.popup_wrapper.querySelectorAll('.skoda-form');

        forms.forEach(form => {
            new CF7_Field_Validator(form);
        });
    }

    hidePopupAfterSubmit()
    {

        const cf7 = this.popup_wrapper.querySelector('.wpcf7');

        cf7.addEventListener('wpcf7submit', (event) => {
            if ('mail_sent' === event.detail.status) {
                setTimeout(() => {
                    this.closePopup();
                }, 2000)
            }
        })
    }

    showMoreText()
    {
        let texts = document.querySelectorAll('.more');

        console.log(texts);
        texts.forEach((text) => {

            let more_content = text.querySelector('.has-more');

            if (!more_content) {
                return;
            }

            let btn = document.createElement("BUTTON");
            btn.style.color = 'green';
            btn.innerHTML = "Czytaj więcej";
            more_content.style.display = 'none';
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                btn.innerHTML = (btn.innerHTML === 'Czytaj więcej') ? 'Ukryj ' : 'Czytaj więcej';
                more_content.style.display = ( more_content.style.display === 'none') ? 'inline' : 'none';
            })

        text.insertBefore(btn,more_content);

        })
    }

    pseudoDatcePickers()
    {
        const dates_inputs = document.querySelectorAll('input.datepicker');
        dates_inputs.forEach((date) => {
            date.addEventListener('focusin', (event) => {
                date.type = 'date';
            });

        date.addEventListener('focusout', (event) => {
            date.type = 'text';
          });
        })
    }

    animateLabels()
    {
        let inputs = document.querySelectorAll('input:not([type="submit"]), select, textarea');

        inputs.forEach((input) => {

            input.addEventListener('focusin', (event) => {
                input.parentElement.classList.add('focusin');
            });

        input.addEventListener('focusout', (event) => {
            input.parentElement.classList.remove('focusin');
          });


        input.addEventListener('change', (event) => {
            const tag = input.tagName.toLowerCase();
            let has_value = false;
            has_value = (input.value) ? true : false;

            if (has_value) {
                input.parentElement.classList.add('has-value');
            } else {
                input.parentElement.classList.remove('has-value');
            }
          });
        })
    }
}
